import * as React from 'react';
import { InputFeedback } from '../form-elements/InputFeedback';

type InputType = 'text' | 'number';

// #region Component Props

interface IProps {
    type        : InputType;
    id          : string;
    value       : any;
    onChange    : any;
    classList   : string;
    error       : string;
    name        : string;
}

// #endregion

export const EditTextCell = (props: IProps) => {

    const { type, id, value, onChange, classList, error, name } = props;

    return <td className={'editing-cell ' + classList }>
                <input 
                    type={ type }
                    name={ name }
                    className="form-control"
                    id={ id }
                    value={ value ? value : '' }
                    onChange={ onChange } />
                {
                    error ? <InputFeedback error={ error } /> : <span/>
                }
            </td>
}